export enum DesignLeftSideBarTabs {
  CEILING_VALIDATIONS = "CEILING_VALIDATIONS",
  CEILING_HELP = "CEILING_HELP",
  CEILING_SETTINGS = "CEILING_SETTINGS",
}

export enum RoomSideBarTabs {
  CEILING_MULTIPLACER_PRODUCTS = "CEILING_MULTIPLACER_PRODUCTS",
  CEILING_STANDARD_ROOM = "CEILING_STANDARD_ROOM",
  CEILING_VALIDATIONS = "CEILING_VALIDATIONS",
  CEILING_AI_PREDICTIONS = "CEILING_AI_PREDICTIONS",
  RFP_STANDARD_ROOM_DIFF = "RFP_STANDARD_ROOM_DIFF",
  ROOM_SPECIFIED_ARTICLES = "ROOM_SPECIFIED_ARTICLES",
  ROOM_INFO = "ROOM_INFO",
}
